"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.CustomerScenario = void 0;
// TODO: Remove once frontend migrates to CustomerType
var CustomerScenario;
(function (CustomerScenario) {
    CustomerScenario["New"] = "NEW_CUSTOMER";
    CustomerScenario["ExistingConsumer"] = "EXISTING_CONSUMER";
    CustomerScenario["ExistingConsumerWithCard"] = "EXISTING_CONSUMER_WITH_CARD";
    CustomerScenario["ExistingSoho"] = "EXISTING_SOHO";
})(CustomerScenario || (exports.CustomerScenario = CustomerScenario = {}));
